module.exports = __webpack_public_path__ + "assets/img/1423.beb92e7d.png";